import i18next from "i18next"


export function errorHandler(code) {
	var error = i18next.t('errorHandler.request_error')

	switch (code) {
		case 'ER_DUP_ENTRY':
			error = i18next.t('errorHandler.idptu_no_dup');
			break;

		case 'ALREADY_8':
			error = i18next.t('errorHandler.8_products');
			break;

		case 'NO_RIGHT':
			error = i18next.t('errorHandler.no_rights')
			break;

		case 'NO_RIGHT_DEMO':
			error = i18next.t('errorHandler.action_forbidden')
			break;

		default:
			error = i18next.t('errorHandler.request_error')


	}
	return error;
}